import React, { useState } from "react";

const gemstoneFamilies = [
  {
    label: "Precious Gemstones",
    types: ["Diamond", "Ruby", "Sapphire", "Emerald", "Navratan", "Pearl"]
  },
  {
    label: "Semi-Precious Gemstones",
    types: [
      "Opal",
      "Garnet",
      "Topaz",
      "Amethyst",
      "Citrine",
      "Peridot",
      "Aquamarine",
      "Tourmaline",
      "Tanzanite",
      "Spinel",
      "Morganite",
      "Alexandrite",
      "Coral",
      "Moonstone",
      "Turquoise",
      "Jade",
      "Onyx",
      "LapisLazuli",
      "TigerEye",
      "Kunzite"
    ]
  }
];

const defaultFields = ["Type", "Weight", "Size", "Shape", "Quality", "Pieces"];

const gemstoneTypeOptions = {
  Diamond: ["Natural Diamond", "Lab Diamond"],
  Emerald: ["Natural Emerald", "Lab Grown Emerald"],
  Ruby: ["Natural Ruby", "Lab Grown Ruby"],
  Sapphire: [
    "Blue Sapphire",
    "Pink Sapphire",
    "Green Sapphire",
    "Yellow Sapphire",
    "White Sapphire",
    "Purple Sapphire",
    "Multi Sapphire",
    "Black Sapphire",
    "Orange Sapphire",
    "Teal Sapphire",
    "Colorless Sapphire",
    "Padparadscha Sapphire",
    "Parti Sapphire"
  ],
  Opal: ["White Opal", "Black Opal", "Fire Opal"],
  Garnet: ["Red Garnet", "Green Garnet"],
  Topaz: ["Blue Topaz", "Imperial Topaz"],
  Amethyst: ["Natural Amethyst"],
  Navratan: ["Navratan"],
  Pearl: ["South Sea", "Cultured"],
  Citrine: ["Citrine"],
  Peridot:["Green Peridot", "Deep Olive"],
  Aquamarine:["Blue Aquamarine","Green Aquamarine"],
  Tourmaline:["Pink", "Green","Blue","Yellow","Orange"],
  Tanzanite:["Purple Blue"],
  Spinel:["Green","Blue","Red","Pink","Orange","Yellow"],
  Morganite:["Morganite"],
  Alexandrite:["Alexandrite"],
  Coral:["Red","White", "Orange", "Black"],
  Moonstone:["Moonstone"],
  Turquoise:["Blue","Green"],
  Jade:["Green","Orange","Blue"],
  Onyx:["Green", "Black","Red" , "Blue"],
  LapisLazuli:["Lapis Lazuli"],
  TigerEye:["Tiger Eye"],
  Kunzite:["Kunzite"]
};

const qualityOptions = ["HI SI", "GH VS", "GH VVS", "EF VVS", "FG VVS1"];

export default function DynamicGemstoneCells({ cells, setCells, family, setFamily }) {
  const [selectedType, setSelectedType] = useState("");

  const getFamilyTypes = () => gemstoneFamilies.find((f) => f.label === family)?.types || [];

  const addCells = () => {
    if (!family || !selectedType) return;

    const updatedCells = { ...cells };
    if (!updatedCells[selectedType]) {
      updatedCells[selectedType] = [];
    }

    updatedCells[selectedType].push({
      Type: "",
      Weight: "",
      Size: "",
      Shape: "",
      Quality: "",
      Pieces: "",
      family,
      _isNew: true
    });

    setCells(updatedCells);
  };

  const updateField = (type, index, field, value) => {
    setCells((prev) => {
      const updatedTypeForms = [...prev[type]];
      updatedTypeForms[index] = {
        ...updatedTypeForms[index],
        [field]: value
      };

      return {
        ...prev,
        [type]: updatedTypeForms
      };
    });
  };

  const removeCell = (type, index) => {
    setCells((prev) => {
      const updated = { ...prev };
      const forms = [...(updated[type] || [])];
      forms.splice(index, 1);

      if (forms.length === 0) {
        delete updated[type];
      } else {
        updated[type] = forms;
      }

      return updated;
    });
  };

  return (
    <div style={{ padding: "0px", margin: "auto" }}>
      <div style={{ marginBottom: "20px" }}>
        <label>Select Gemstone Family</label>
        <select
          value={family}
          onChange={(e) => {
            const newFamily = e.target.value;
            setFamily(newFamily);
            setSelectedType("");
          }}
          style={{ width: "100%", padding: "10px", marginTop: "6px" }}
        >
          <option value="">Select Family</option>
          {gemstoneFamilies.map((f) => (
            <option key={f.label}>{f.label}</option>
          ))}
        </select>
      </div>

      {family && (
        <div style={{ marginBottom: "20px" }}>
          <label>2. Select Gemstone Type</label>
          <select
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
            style={{ width: "100%", padding: "10px", marginTop: "6px" }}
          >
            <option value="">Select Type</option>
            {getFamilyTypes().map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
      )}

      <button
        onClick={addCells}
        style={{
          padding: "10px 20px",
          background: "#1a73e8",
          color: "#fff",
          borderRadius: "8px",
          cursor: "pointer",
          marginBottom: "20px"
        }}
        type="button"
        disabled={!family || !selectedType}
      >
        Add Cell
      </button>

      <div>
        {Object.keys(cells).map((type) =>
          cells[type]
            .map((form, index) => {
              // Always show manually-added cells (_isNew).
              // For CSV-imported cells, only show if they have meaningful data.
              const hasData = !!(
                form?.Weight ||
                form?.Size ||
                form?.Shape ||
                form?.Quality ||
                form?.Pieces
              );
              if (!form?._isNew && !hasData) return null;

              return (
                <div
                  key={`${type}-${index}`}
                  style={{
                    border: "1px solid #ccc",
                    padding: "20px",
                    borderRadius: "10px",
                    marginBottom: "25px"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "12px"
                    }}
                  >
                    <h3 style={{ margin: 0 }}>
                      {form.family || family} - {type} (Form #{index + 1})
                    </h3>
                    <button
                      type="button"
                      onClick={() => removeCell(type, index)}
                      style={{
                        padding: "6px 12px",
                        background: "#d32f2f",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer"
                      }}
                    >
                      Close
                    </button>
                  </div>

                  {(() => {
                    const fieldsToRender = defaultFields.filter((f) => f !== "Quality" || type === "Diamond");

                    return fieldsToRender.map((field) => (
                      <div key={field} style={{ marginBottom: "12px" }}>
                        <label>{`${type} ${field}`}</label>

                        {field === "Type" ? (
                          <select
                            value={form.Type}
                            onChange={(e) => updateField(type, index, "Type", e.target.value)}
                            style={{
                              width: "100%",
                              padding: "10px",
                              marginTop: "5px",
                              borderRadius: "5px",
                              border: "1px solid #ddd"
                            }}
                          >
                            <option value="">Select {type} Type</option>
                            {(gemstoneTypeOptions[type] || []).map((opt) => (
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            ))}
                          </select>
                        ) : field === "Quality" ? (
                          <select
                            value={form[field] || ""}
                            onChange={(e) => updateField(type, index, field, e.target.value)}
                            style={{
                              width: "100%",
                              padding: "10px",
                              marginTop: "5px",
                              borderRadius: "5px",
                              border: "1px solid #ddd"
                            }}
                          >
                            <option value="">Select Quality</option>
                            {qualityOptions.map((q) => (
                              <option key={q} value={q}>
                                {q}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={form[field]}
                            onChange={(e) => updateField(type, index, field, e.target.value)}
                            style={{
                              width: "100%",
                              padding: "10px",
                              marginTop: "5px",
                              borderRadius: "5px",
                              border: "1px solid #ddd"
                            }}
                          />
                        )}
                      </div>
                    ));
                  })()}
                </div>
              );
            })
            .filter(Boolean)
        )}
      </div>
    </div>
  );
}
